export default "https://d1e6s5z4lzmgxx.cloudfront.net/e6c6b85e-6085-403a-93bd-a279ec1d3907/images/ob-step-14.png?a4a197bd095f9656bb5d3a3e34e9d2fb";